import { featureFlags } from "@/config/features";

const socialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/aidecoai" },
  { label: "Instagram", href: "https://www.instagram.com/aideco_ai/" },
] as const;

const social = [
  ...socialLinks,
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61567178475837" },
] as const;

const mailingAddress = {
  streetAddress: "169 Madison Ave",
  city: "New York",
  region: "NY",
  postalCode: "10016",
  country: "United States",
} as const;

const mailingAddressText = `${mailingAddress.streetAddress}, ${mailingAddress.city}, ${mailingAddress.region} ${mailingAddress.postalCode}, ${mailingAddress.country}`;

export const siteConfig = {
  name: "Aideco",
  shortName: "Aideco",
  legalEntity: "RETAIL ALLIANCES, INC.",
  legalEntityDba: "d/b/a Aideco",
  /** Footer line tying the brand to its legal entity */
  legalEntityNotice: "Aideco is a product of Retail Alliances, Inc.",
  url: "https://www.aideco.us",
  /** Stable JSON-LD ids so every page's structured data points at the same entities */
  organizationId: "https://www.aideco.us/#organization",
  applicationId: "https://www.aideco.us/#app",
  logoPath: "/logos/Gemini_Generated_Image_icqk2micqk2micqk-optimized-removebg-preview.png",
  description:
    "Aideco transforms CAD drawings into photorealistic, 3D, clay, and sketch renders so architecture teams can present concepts in minutes.",
  /**
   * Free use as the server enforces it (FREE_TIER_CONFIG.dailyGenerations in
   * apps/server/src/db/schema/rate-limit.ts).
   */
  freeTier: { rendersPerDay: 3 },
  tagline: "AI-powered architecture rendering for teams who need stunning visuals fast.",
  locale: "en-US",
  navigation: [
    { href: "/", label: "Home" },
    { href: "/", label: "Products" },
    { href: "/", label: "Solutions" },
    { href: "/#pricing", label: "Pricing" },
    { href: "/about", label: "About" },
    { href: "/contact", label: "Contact" },
  ],
  cta: {
    primary: { href: "/", label: "Request a demo" },
    secondary: { href: "/#pricing", label: "See pricing" },
    footer: {
      href: "/",
      // Free-to-start by default; paid gate switches the footer CTA to the trial wording.
      label: featureFlags.enablePaidGate ? "Start free trial" : "Start for free",
    },
  },
  contact: {
    generalEmail: "hello@aideco.us",
    salesEmail: "sales@aideco.us",
    partnershipsEmail: "partners@aideco.us",
    supportEmail: "support@aideco.us",
  },
  /** Primary mailing address for legal/compliance purposes */
  mailingAddress,
  mailingAddressText,
  offices: [
    {
      label: "New York Office",
      streetAddress: mailingAddress.streetAddress,
      city: mailingAddress.city,
      region: mailingAddress.region,
      postalCode: mailingAddress.postalCode,
      country: "US",
    },
  ],
  socialLinks,
  social,
  trustSignals: [
    "Architecture firms",
    "Design studios",
    "Real estate developers",
    "Interior designers",
    "Construction teams",
  ],
  legal: {
    updated: "2025-09-01",
    termsSummary:
      "Aideco provides AI-powered architectural rendering services governed by standard commercial terms.",
    privacySummary:
      "We collect the minimum personal data required to activate services, process it securely, and never sell it to third parties.",
    cookiesSummary:
      "Our platform uses analytics and authentication cookies to maintain secure sessions and product telemetry.",
    links: [{ href: "/cookies", label: "Cookies Policy" }],
  },
} as const;

/** Adds " | Aideco" to a page title unless the title already names the brand. */
export function titleWithBrand(title: string): string {
  return title.toLowerCase().includes(siteConfig.name.toLowerCase())
    ? title
    : `${title} | ${siteConfig.name}`;
}
